<body>
    <div class="dash">
      <app-sidebar></app-sidebar>
      <div class="dash-app">
        <app-header></app-header>
        <main class="dash-content" style="padding: 20px; margin: 0">
          <div class="container-fluid">
            <div class="row">
              <div class="col-xl-12">
                <div class="card">
                  <div class="card-header">
                    <div class="row">
                      <!-- <div class="col-md-4">
                        TEACHERS
                      </div> -->
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-3">
                            <input
                              type="text"
                              id="gsearch"
                              class="form-control"
                              name="gsearch"
                              style="font-size: 14px"
                              placeholder="search"
                              autocomplete="off"
                            
                            />
                          </div>
                          <div class="col-md-1"></div>
  
                          <div class="col-md-4 text-center">
                            <select
                              class="form-control font-weight-bold"
                              style="text-align-last: center"
                              (change)="onChangeClinic($event.target.value)"
                            >
                              <option
                                *ngFor="
                                  let clinic of clinicArray;
                                  let index = index
                                "
                                [value]="index"
                              >
                                {{ clinic.clinicName }}
                              </option>
                            </select>
                          </div>
  
                          <div class="col-md-1"></div>
                          <div class="col-md-3 text-right">
                            <p-calendar
                              [(ngModel)]="date4"
                              (onSelect)="doSomething()"
                              [readonlyInput]="true"
                              [style]="{ width: '100%' }"
                              [inputStyle]="{ width: '100%' }"
                              placeholder="search by date"
                              inputStyleClass="text-center"
                            ></p-calendar>
  
                            <!--   <button
                              type="button"
                              class="btn btn-primary"
                              style="margin-left: 5px"
                              (click)="cancelAll()"
                            >
                              cancel all appointment
                            </button>
                            <!-    <button
                      type="button"
                      class="btn btn-primary"
                      style="margin-left: 5px;"
                      (click)="confirmAll()"
                    >
                      confirm all appointment
                    </button>-->
                          </div>
  
                          <!--  <div *ngIf="isCross">
                              <button
                                type="button"
                                class="btn btn-primary"
                                (click)="onClearFilter()"
                              >
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </button>
                            </div>-->
                        </div>
                      </div> 
  
                      <div class="col-md-1 text-right"></div>
                    </div>
                  </div>
                  <div class="card-body">
                    <table
                      id="example"
                      class="table table-striped table-bordered"
                      style="width: 100%"
                    >
                      <div *ngIf="!Emergencyappointment" class="text-center">
                        <h4 align="center">No appointments available</h4>
                      </div>
                      <thead *ngIf="Emergencyappointment">
                        <tr>
                          <th id="tb-head">#</th>
                          <th id="tb-head">Paitent Name</th>
                          <th id="tb-head">Patient Number</th>
                          <th id="tb-head">Appointment Date</th>
                          <th id="tb-head">Patient Phone</th>
                          <th id="tb-head">App User</th>
                          <th id="tb-head">Status</th>
                        </tr>
                      <!-- </thead> -->
                      <tbody>
                        <tr
                        class="clickable"
                        style="cursor: pointer"
                        *ngFor="
                          let sinapp of appArray ;
                          let index = index
                        "
                      >
                          <td align="center">
                            P-{{ sinapp?.patientId?.registrationNo }}
                          </td>
                          <td align="center">
                            {{ sinapp?.patientName }}
                          </td>
                          <td align="center">
                            {{ sinapp?.appointmentNumber }}
                          </td>
  
                          <td align="center">
                            {{ moment(sinapp?.appointmentDate).format('MMMM Do YYYY') }}
                          </td>
                          <td align="center">
                            {{ sinapp.patientId.phoneNo }}
                          </td>
  
                          <td align="center">
                            {{ sinapp.patientId.name }}
                          </td>
                          <td align="center">
                            {{ sinapp.appointmentStatus }}
                          </td>
  
                          <td align="center" *ngIf="moment(sinapp?.appointmentDate).format('MMMM Do YYYY')  != moment().format('MMMM Do YYYY')">
                            <!--   <a class="btn btn-default" type="button"
                       (click)=onConfirmAppointment(sinapp.patientId._id,sinapp.appointmentDate,sinapp.appointmentNumber)
  
                        ><em class="fa fa-check"></em
                      ></a>-->
                            <a
                              class="btn btn-defaonConfirmAppointmentult"
                              style="margin-left: 10px"
                              type="button"
                              
                              ><em class="fa fa-times"></em
                            ></a>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot></tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </body>